import Button from '../../general/button/button';
import { CookieUtils, CookieBrowserPreferencesReturn } from '../utils';
import {
  allTrueCookiePreferencesValue,
  essentialOnlyTrueCookiePreferencesValue,
} from '../constants';
import styles from './page-one.module.scss';
import LanguageSelector from '../../general/language-selector/language-selector';
import { sanitizeHtml } from '../../../helpers/sanitize';

type Props = {
  onClose: (preferences: CookieBrowserPreferencesReturn) => void;
  nextPage: () => void;
  languageSelector: any;
  cookieUtils: CookieUtils;
  privacyPolicyUrl: string;
};

export const PageOne = ({
  onClose,
  nextPage,
  languageSelector,
  cookieUtils,
  privacyPolicyUrl,
}: Props) => {
  return (
    <>
      <div className={styles['language-row']}>
        <div className={styles['language-wrapper']}>
          <LanguageSelector {...languageSelector} small />
        </div>
      </div>
      <div className={styles['body-section']}>
        <h1 className={styles.header}>
          {polyglot.t('cookie_policy.page_one.header')}
        </h1>
        <p>{polyglot.t('cookie_policy.page_one.body')}</p>
        <p
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(
              polyglot.t('cookie_policy.page_one.policy_text_link', {
                url: privacyPolicyUrl,
              }),
            ),
          }}
        />
      </div>
      <div className={styles['button-section']}>
        <div className={styles['button-wrapper']}>
          <Button
            dataHook={'manage-cookies'}
            text={polyglot.t('cookie_policy.page_one.manage_cookies')}
            onClick={nextPage}
            theme='text--on-surface'
          />
        </div>
        <div className={styles['button-wrapper']}>
          <Button
            dataHook='essential-cookies-only'
            text={polyglot.t('cookie_policy.page_one.allow_essential_cookies')}
            theme='outlined--on-surface'
            size='small'
            onClick={() => {
              const preferences = cookieUtils.setCookieBrowserPreferences(
                essentialOnlyTrueCookiePreferencesValue,
              );
              onClose(preferences);
            }}
          />
        </div>
        <div className={styles['button-wrapper']}>
          <Button
            dataHook={'accept-cookies'}
            text={polyglot.t('cookie_policy.page_one.accept_cookies')}
            size='small'
            onClick={() => {
              const preferences = cookieUtils.setCookieBrowserPreferences(
                allTrueCookiePreferencesValue,
              );
              onClose(preferences);
            }}
          />
        </div>
      </div>
    </>
  );
};

PageOne.displayName = 'PageOne';
